<template>
  <router-view/>
  <div v-if="buildVersion && debug.debugEnabled" class="build-version" :title="buildVersion">{{ buildVersion }}</div>
</template>

<script setup lang="ts">
import { useDebugStore } from './stores/debugStore'
import { useServiceWorker } from './composables/useServiceWorker'

const debug = useDebugStore()
useServiceWorker()

// Короткая версия ГГММДД-ЧЧММСС-<9> целиком помещается в бэйдж (~22 символа).
const buildVersion = typeof (process.env.BUILD_VERSION as any) !== 'undefined'
  ? process.env.BUILD_VERSION as unknown as string
  : undefined
</script>

<style scoped>
.build-version {
  position: fixed;
  top: max(8px, env(safe-area-inset-top, 8px));
  left: max(8px, env(safe-area-inset-left, 8px));
  font-size: 10px;
  line-height: 1;
  color: #fff;
  opacity: 0.35;
  /* Отладочный элемент фиксируется по размеру своего текста (position: fixed + инлайновое
     содержимое), поэтому auto включает hover-тултип (title с полным хешем), не перекрывая
     клики по обычному UI — за пределами крошечного текста версии событий нет. */
  pointer-events: auto;
  z-index: 9999;
  font-family: monospace;
  user-select: none;
}
</style>
